import InsightsPage from './InsightsPage'

export default InsightsPage
